import template from './loadingIndicator.html';
import controller from './loadingIndicator.controller';

let LoadingIndicatorComponent = {
  restrict: 'E',
  template,
  controller
};

export default LoadingIndicatorComponent;



// WEBPACK FOOTER //
// ./client/common/loadingIndicator/loadingIndicator.component.js